<template>
  <CFooter :fixed="false">
    <div>
      <a href="http://www.tech9.kr" target="_blank">Tech9</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} creativeLabs.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="http://www.tech9.kr">Tech9 for Smart IoT</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
